module.exports = "div.main {\n  font-family: QuicksandRegular;\n}\n"